import React from 'react';
import PropTypes from 'prop-types';
import LinkHandler from '../../link-handler';

import {
  Distance,
  ShopBody,
  ShopHeading,
  ShopItemIcon,
  ShopItemWrapper,
} from '../styles';

/**
 * Displays name and distance to the service centres, linking to that service  page
 */

const Item = ({ last = false, navigation, name, distance }) => (
  <ShopItemWrapper>
    <ShopItemIcon width="20px" />
    <ShopBody last={last}>
      <ShopHeading>
        <LinkHandler link={navigation}>{name}</LinkHandler>
      </ShopHeading>
      {distance && <Distance>{distance.toFixed(1)} miles away</Distance>}
    </ShopBody>
  </ShopItemWrapper>
);

const ServiceListing = ({ filteredServices }) => (
  <div data-testid="results">
    <h2>
      {`Your nearest service${
        filteredServices.length === 1 ? ` is` : `s are`
      }:`}
    </h2>
    <div data-testid="results-list">
      {filteredServices.map((s, i) => (
        <Item
          key={`${i}${s.serviceName.slice(0, 5)}`}
          last={i === filteredServices.length - 1}
          navigation={s.navigation}
          name={s.serviceName}
          distance={s.distance}
        />
      ))}
    </div>
  </div>
);

Item.propTypes = {
  last: PropTypes.bool,
  navigation: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  distance: PropTypes.number,
};

ServiceListing.propTypes = {
  filteredServices: PropTypes.array.isRequired,
};

export default ServiceListing;
